import React from "react";
import { CheckOutlined } from "@ant-design/icons";

/**
 * Sent/read indicator: a single check, accent-colored once read. Zulip only
 * tracks read (not delivered), so there's no third "delivered" state to
 * render — see the callers' own comments on why a still-plain check can
 * simply mean the recipient has read receipts off.
 */
const ReadReceiptTicks: React.FC<{ seen: boolean; className?: string }> = ({ seen, className }) => (
  <span className={`chat-receipt-ticks${seen ? " chat-receipt-ticks--seen" : ""}${className ? ` ${className}` : ""}`}>
    <CheckOutlined />
  </span>
);

export default ReadReceiptTicks;
